import { FC } from "react";
import { AppButton } from "site/ui";
import styled from "styled-components";

const SectionTitle = styled.h2`
    margin: 0 0 20px 0;
    font-size: 18px;
    font-weight: 600;
    color: #5575f7;
`;
const SubText = styled.p`
  margin: 5px 0;
  font-size: 14px;
  color: #6c757d;
`;
  export interface ConnectionsProps {

  }
  export const Connections:FC<ConnectionsProps> = ({

  }) => {
    return (
      <div>
        <SectionTitle>Connections</SectionTitle>
        <h4>Connected devices</h4>
        <SubText>
          Log out of all devices if your account is currently active on multiple
          devices.
        </SubText>
        <AppButton variant="accent" style={{ marginTop: 20, marginBottom: 30 }}>
          Log out from all devices
        </AppButton>

        <h4>Linked accounts</h4>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            margin: "15px 0",
          }}
        >
          <div>Google</div>
          <AppButton variant="accent">Unlink account</AppButton>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            margin: "15px 0",
          }}
        >
          <div>Apple</div>
          <AppButton variant="accent">Unlink account</AppButton>
        </div>
      </div>
    );
  };